export default __webpack_public_path__ + "static/media/hhi.a5e7246d.png";